import React from "react";

export default function GradientRectangle({
  title,
  subtitle,
  stops,
  orientation = "vertical",
}) {
  const isHorizontal = orientation === "horizontal";
  const gradientStops = stops
    .map((stop) => `${stop.color} ${stop.position * 100}%`)
    .join(", ");

  return (
    <div className="legend-card">
      <div className="legend-header">
        <div className="panel-label">{title}</div>
        <div className="legend-subtitle">{subtitle}</div>
      </div>

      <div className={`legend-body legend-body--${orientation}`}>
        <div className={`legend-scale legend-scale--${orientation}`}>
          <div
            className="legend-track"
            style={{ background: `linear-gradient(${isHorizontal ? "to right" : "to bottom"}, ${gradientStops})` }}
          />
        </div>

        <div className={`legend-labels legend-labels--${orientation}`}>
          {stops.map((stop) => (
            <div
              key={`${title}-${stop.label}-${stop.position}`}
              className={`legend-label legend-label--${orientation}`}
              style={isHorizontal
                ? {
                  left: `${stop.position * 100}%`,
                  transform: stop.position === 0
                    ? "translateX(0)"
                    : stop.position === 1
                      ? "translateX(-100%)"
                      : "translateX(-50%)",
                }
                : { top: `${stop.position * 100}%` }}
            >
              {stop.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
